export default "__VITE_ASSET__DuJ0fDeo__"